import { useEffect, useRef, useState } from 'react';

import DatePicker, { registerLocale } from 'react-datepicker';
import { Controller as ControllerBase } from 'react-hook-form';

import { setClass } from '../../helpers/utils';
import './styles.scss';
import 'react-datepicker/dist/react-datepicker.css';

import { es } from 'date-fns/esm/locale';

import { Calendar as IconCalendar } from '../../components/Icons/Calendar';

registerLocale('es', es);

const Controller = ControllerBase as any;

type InputDatePickerProps = {
	className?: string;
	type?: string;
	id?: string;
	name?: string;
	placeholder?: string;
	disabled?: boolean;
	onBlur?: (...args: unknown[]) => void;
	onChange?: (...args: unknown[]) => void;
	onKeyDown?: (...args: unknown[]) => void;
	onClick?: (...args: unknown[]) => void;
	size?: string;
	minDate?: Date;
	maxDate?: Date;
	hookForm?: any;
	onCalendarOpen?: () => void;
	onCalendarClose?: () => void;
};

export const InputDatePicker = ({
	className = '',
	type = 'text',
	id,
	name,
	placeholder,
	disabled = false,
	onBlur,
	onChange,
	onKeyDown,
	onClick,
	size = '',
	minDate,
	maxDate,
	hookForm = { formState: { errors: {} } } as any,
	onCalendarOpen = () => {},
	onCalendarClose = () => {},
}: InputDatePickerProps) => {
	const [isFocus, setIsFocus] = useState(false);
	const [isFill, setIsFill] = useState(false);
	const inputEl = useRef(null);

	const {
		control,
		watch,
		formState: { errors },
	} = hookForm;

	const typeSize = {
		medium: 'is-medium',
	};

	const isSize = typeSize[size] || '';

	const handleBlur = (event) => {
		setIsFocus(false);
		setIsFill(!isEmptyValue());

		if (typeof onBlur === 'function') {
			onBlur(event);
		}
	};

	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	// const handleKeyDown = (event) => {
	//   if (typeof onKeyDown === "function") {
	//     onKeyDown(event);
	//   }
	// };
	const watchInput = watch?.(name, true);
	const isEmptyValue = () => {
		const elem = inputEl.current;
		const input = elem.querySelector('input');
		return !(input?.value?.trim().length > 0);
	};

	const openDatePicker = () => {
		const elem = inputEl.current;
		const input = elem.querySelector('input');
		input.focus();
	};

	useEffect(() => {
		setIsFill(!isEmptyValue());
	}, [watchInput]);

	return (
		<div
			ref={inputEl}
			className={setClass(`input input-datepicker icon-right
        ${isFill || isFocus ? 'is-fill' : ''}
        ${isSize}
        ${disabled ? 'is-disabled' : ''}
        ${errors[name] ? 'is-error' : ''}
        ${className}`)}
		>
			<span className="button-calendar" onClick={() => openDatePicker()}>
				<IconCalendar />
			</span>
			<label>{placeholder}</label>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, onBlur, value, ref } }) => (
					<DatePicker
						selected={
							value && new Date(new Date(value).getTime() + 5 * 60 * 60 * 1000)
						}
						onChange={(e) => {
							onChange(e);
							handleChange(e);
						}}
						onBlur={(e) => handleBlur(e)}
						onFocus={() => setIsFocus(true)}
						// dateFormat="yyyy/MM/dd"
						dateFormat="dd/MM/yyyy"
						disabled={disabled}
						minDate={new Date(minDate)}
						maxDate={new Date(maxDate)}
						locale="es"
						onCalendarOpen={() => onCalendarOpen()}
						onCalendarClose={() => onCalendarClose()}
					/>
				)}
			/>
			{errors[name] && (
				<span className="message-error">{errors[name].message}</span>
			)}
		</div>
	);
};
